import Component from "../abstracts/Component";

export default class LoaderComponent extends Component {
  get SELECTORS() {
    return {
      main: 'body',
      global: '[data-loader-global]',
      localCta: '[data-loader-local]',
      pointers: '.js-pointers',
      localLoader: '.js-loader'
    }
  }

  get CLASSES() {
    return {
      loading: 'loading'
    }
  }

  get LOADERS_MARKUP() {
    return {
      local: () => {
        const markup = `<div class="local-loader"><!----></div>`;
        return new DOMParser().parseFromString(markup, 'text/html');
      }
  
    }
  }

  constructor() {
    super();
    this.globalLoaders = [];
  }
  

  showGlobalLoader(timeStamp) {
    return new Promise((resolve, reject) => {
      try {
        const main = document.querySelector(this.SELECTORS.main);
        this.globalLoaders.push(timeStamp);
        main.classList.add(this.CLASSES.loading);

        resolve(this.$customEvents.LOADER_EVENTS.visible);
      } catch (e) {
        reject(e);
      }
    });
  }

  showLocalLoader(el, loadertype) {

    if (el.hasClass('loading-cta')) return;
    
    return new Promise((resolve, reject) => {
      try {
        switch(loadertype) {
          case "loader-wheel": {
            var loader = '<img src="/docroot/maxmara/public/loader-wheel.gif" class="loader-wheel js-loader" />';
            break;
          }
          /*default: {
            var loader = '<div class="js-pointers js-loader pointers"><span></span><span></span><span></span></div>';
          }*/
        }
        el.addClass('loading-cta')
        el.append(loader);
        this.log('Show local loader', el);
      } catch (e) {
        reject(e);
      }
    });
  }

  hideLocalLoader(el) {

    return new Promise((resolve, reject) => {
      try {
        $(this.SELECTORS.localLoader).fadeOut();
        el.removeClass('loading-cta')
        el.addClass('success');
        setTimeout(  () => { 
          el.removeClass('success'); 
          $(this.SELECTORS.localLoader).remove();
        }, 3000);
        this.log('Hide local loader', el);
      } catch (e) {
        reject(e);
      }
    });
    
  }



  hideGlobalLoader() {
    return new Promise((resolve, reject) => {
      try {
        const main = document.querySelector(this.SELECTORS.main);
        if (this.globalLoaders.length > 0) this.globalLoaders.pop();

        if (this.globalLoaders.length === 0) {
          main.classList.remove(this.CLASSES.loading);
          resolve(this.$customEvents.LOADER_EVENTS.hidden);
        } else {
          resolve(false);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  bindEvents() {

    this.$on(this.$customEvents.LOADER_EVENTS.showLocal, ({event, payload}) => {
      this.showLocalLoader(payload.button, payload.loadertype);
    });

    this.$on(this.$customEvents.LOADER_EVENTS.hideLocal, ({event, payload}) => {
      this.hideLocalLoader(payload.button);
    });
    

    this.$on(this.$customEvents.LOADER_EVENTS.show, ({event, payload}) => {

      this.showGlobalLoader(event.timeStamp).then(res => {
        this.$emit(res);
      });
    }, this.SELECTORS.global);

    this.$on(this.$customEvents.LOADER_EVENTS.hide, ({event, payload}) => {
      this.hideGlobalLoader().then(res => {
        if (res) this.$emit(res);
      });
    }, this.SELECTORS.global);
  }

  render() {
    if (document.querySelector(this.SELECTORS.global)) this.bindEvents();
  }

}
